var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pipe } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
var TitlePipe = /** @class */ (function () {
    function TitlePipe(comProv) {
        this.comProv = comProv;
    }
    TitlePipe.prototype.transform = function (page) {
        var title = '';
        var drawer_list = this.comProv.getDrawer();
        if (drawer_list.length > 0) {
            var drawer_data = drawer_list.find(function (element) { return element['page_target'] == page; });
            if (drawer_data) {
                title = drawer_data['title'];
            }
        }
        return title;
    };
    TitlePipe = __decorate([
        Pipe({
            name: 'title',
        }),
        __metadata("design:paramtypes", [CommonProvider])
    ], TitlePipe);
    return TitlePipe;
}());
export { TitlePipe };
//# sourceMappingURL=title.js.map


// WEBPACK FOOTER //
// ./src/pipes/title/title.ts.pre-build-optimizer.js